<template>
  <v-form class="mb-2">
    <v-alert class="mb-7 py-3" type="warning" dense>
      如無公告之場次表示已停止預約或額滿
    </v-alert>
    <v-select
      :items="行政區"
      v-model="selected.行政區"
      label="行政區（必填）"
      no-data-text="暫無資料"
      outlined
      dense
    ></v-select>
    <v-select
      :items="日期地點"
      v-model="selected.日期地點"
      label="日期與地點（必填）"
      no-data-text="暫無資料"
      outlined
      dense
    ></v-select>
    <v-select
      :items="時段"
      v-model="selected.時段"
      label="時段（必填）"
      no-data-text="暫無資料"
      outlined
      dense
      hide-details
    ></v-select>
    <v-checkbox
      v-if="執行成健 && city.name == '臺南市'"
      v-model="整合式篩檢"
      label="僅顯示市府整合式篩檢場次"
      outlined
      hide-details
    ></v-checkbox>
  </v-form>
</template>

<script>
import { city } from "@/../env.js";
export default {
  name: "reserveSection",
  props: ["selectedPerson"],
  data: () => ({
    整合式篩檢: false,
    person: null,
    rawSections: [],
    selected: {
      行政區: null,
      日期地點: {
        日期: null,
        地點: null,
      },
      時段: null,
    },
    city,
  }),
  computed: {
    sections() {
      let sections = this.rawSections;
      if (this.整合式篩檢) {
        sections = sections.filter((o) => o.整合式篩檢);
      }
      // console.log(sections);
      return sections;
    },
    執行成健() {
      // console.log(this.person.篩檢項目);
      return this.person?.篩檢項目?.成健 || false;
    },
    行政區() {
      let 行政區 = this.sections
        .filter((section) => this.getSectionCoverage(section).可執行數量 > 0)
        .map((section) => section.行政區?.replace(/[0-9]/g, "") || "");
      return [...new Set(行政區)];
    },
    日期地點() {
      const 需求項目 = this.getRequestedItems();
      const 符合場次 = this.sections
        .filter((section) =>
          this.selected.行政區
            ? (section.行政區?.replace(/[0-9]/g, "") || "") ==
              this.selected.行政區
            : true
        )
        .filter((section) => (this.執行成健 ? true : !section.整合式篩檢))
        .filter(
          (section) =>
            this.getSectionCoverage(section, 需求項目).可執行數量 > 0
        );

      const 場次群組 = _.groupBy(
        符合場次,
        (section) => `${section.日期}\u0000${section.地點}`
      );

      return Object.values(場次群組)
        .map((sections) => {
          const 代表場次 = sections[0];
          const 覆蓋狀態 = sections.map((section) =>
            this.getSectionCoverage(section, 需求項目)
          );
          const 最佳覆蓋 = _.maxBy(覆蓋狀態, "可執行數量");
          const 覆蓋組合數 = new Set(
            覆蓋狀態.map((coverage) => coverage.可執行項目.join("\u0000"))
          ).size;

          let text = `${代表場次.日期} ${代表場次.地點}`;
          if (覆蓋組合數 > 1) {
            text += " (各時段提供項目不同)";
          } else if (!最佳覆蓋.全部可執行) {
            text += ` (僅提供${最佳覆蓋.可執行項目.join(",")})`;
          }

          return {
            text,
            value: {
              日期: 代表場次.日期,
              地點: 代表場次.地點,
            },
            行政區: 代表場次.行政區,
            全部可執行: 最佳覆蓋.全部可執行,
            可執行數量: 最佳覆蓋.可執行數量,
          };
        })
        .sort(this.compareCoverage)
        .map(({ 全部可執行, 可執行數量, ...item }) => item);
    },
    時段() {
      const 需求項目 = this.getRequestedItems();
      return this.sections
        .filter(
          (section) =>
            section.日期 == this.selected.日期地點.日期 &&
            section.地點 == this.selected.日期地點.地點
        )
        // .filter((section) => (this.執行成健 ? true : !section.整合式篩檢))
        .map((section) => ({
          section,
          coverage: this.getSectionCoverage(section, 需求項目),
        }))
        .filter(({ coverage }) => coverage.可執行數量 > 0)
        .map(({ section, coverage }) => {
          let text = `${section.開始時間}-${section.結束時間} (尚有${
            section.人數上限 - section.已預約
          }個名額)`;
          if (!coverage.全部可執行) {
            text += ` (僅提供${coverage.可執行項目.join(",")})`;
          }
          return {
            text,
            value: section._id,
            全部可執行: coverage.全部可執行,
            可執行數量: coverage.可執行數量,
            開始時間: section.開始時間,
          };
        })
        .sort(this.compareCoverage)
        .map(({ 全部可執行, 可執行數量, 開始時間, ...item }) => item);
    },
  },
  async created() {
    this.rawSections = (await this.axios.get("/sections")).data;
    this.person = this.selectedPerson || { ...this.$store.state.person };
  },
  methods: {
    getRequestedItems() {
      return Object.keys(_.pickBy(this.person?.篩檢項目 || {}, Boolean));
    },
    getSectionCoverage(section, 需求項目 = this.getRequestedItems()) {
      const 可執行項目 = 需求項目.filter(
        (key) => !section.篩檢項目 || section.篩檢項目[key]
      );
      return {
        可執行項目,
        可執行數量: 可執行項目.length,
        全部可執行:
          需求項目.length > 0 && 可執行項目.length == 需求項目.length,
      };
    },
    compareCoverage(a, b) {
      if (a.全部可執行 != b.全部可執行) {
        return a.全部可執行 ? -1 : 1;
      }
      if (a.可執行數量 != b.可執行數量) {
        return b.可執行數量 - a.可執行數量;
      }

      const aDate = a.value?.日期 || "";
      const bDate = b.value?.日期 || "";
      if (aDate != bDate) return aDate.localeCompare(bDate);

      const aTime = a.開始時間 || "";
      const bTime = b.開始時間 || "";
      if (aTime != bTime) return aTime.localeCompare(bTime);

      const aPlace = a.value?.地點 || "";
      const bPlace = b.value?.地點 || "";
      return aPlace.localeCompare(bPlace, "zh-Hant");
    },
  },
  watch: {
    "selected.行政區"() {
      this.selected.日期地點 = {
        日期: null,
        地點: null,
      };
      this.selected.時段 = null;
    },
    "selected.日期地點"() {
      this.selected.時段 = null;
    },
    "selected.時段"(val) {
      this.$emit("input", val);
    },
  },
};
</script>
